import ConfigurationList from '@/pages/routing/ConfigurationList.vue'
import FormatList from '@/pages/routing/FormatList.vue'
import InterProcessConfigurationDetails from '@/pages/routing/InterProcessConfigurationDetails.vue'
import MessageList from '@/pages/routing/MessageList.vue'
import MessageDetails from '@/pages/routing/MessageDetails.vue'
import MQSeriesConfigurationDetails from '@/pages/routing/MQSeriesConfigurationDetails.vue'
import RemoteFolderConfigurationDetails from '@/pages/routing/RemoteFolderConfigurationDetails.vue'
import WebServiceConfigurationDetails from '@/pages/routing/WebServiceConfigurationDetails.vue'
import RTPNormList from '@/pages/routing/RTPNormList.vue'
import RTPNormForm from '@/pages/routing/RTPNormForm.vue'

export default [
  {
    path: '/routing/configurationList/:type',
    component: ConfigurationList,
    props: true
  },
  {
    path: '/routing/formatList',
    component: FormatList,
    props: true
  },
  {
    path: '/routing/interProcessConfigurationDetails/:mode',
    component: InterProcessConfigurationDetails,
    props: true
  },
  {
    path: '/routing/messageDetails/:mode/:role',
    component: MessageDetails,
    props: true
  },
  {
    path: '/routing/messageList/:roleFromURL',
    component: MessageList
  },
  {
    path: '/routing/mqseriesConfigurationDetails/:mode',
    component: MQSeriesConfigurationDetails,
    props: true
  },
  {
    path: '/routing/remoteFolderConfigurationDetails/:mode',
    component: RemoteFolderConfigurationDetails,
    props: true
  },
  {
    path: '/routing/webServiceConfigurationDetails/:mode',
    component: WebServiceConfigurationDetails,
    props: true
  },
  {
    path: '/routing/norm/list',
    component: RTPNormList
  },
  {
    path: '/routing/norm/form/:id',
    component: RTPNormForm,
    props: true
  }
]
